// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { isDarkMode } from '../../provider/types';
import { grey } from '../../tokens/primitiveColors/grey';
export var CssBaseline = function(mode) {
    var isDark = isDarkMode(mode);
    var scrollbarTrack = isDark ? grey[800] : grey[100];
    var scrollbarThumb = isDark ? grey[600] : grey[400];
    var scrollbarThumbHover = grey[500];
    var override = {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    colorScheme: mode
                },
                body: {
                    transition: 'background-color 0.2s ease, color 0.2s ease'
                },
                a: {
                    color: 'inherit'
                },
                '*::-webkit-scrollbar': {
                    width: '8px',
                    height: '8px'
                },
                '*::-webkit-scrollbar-track': {
                    background: scrollbarTrack,
                    borderRadius: '4px'
                },
                '*::-webkit-scrollbar-thumb': {
                    background: scrollbarThumb,
                    borderRadius: '4px',
                    '&:hover': {
                        background: scrollbarThumbHover
                    }
                },
                '*': {
                    scrollbarWidth: 'thin',
                    scrollbarColor: "".concat(scrollbarThumb, " ").concat(scrollbarTrack)
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=CssBaseline.js.map